var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#1B1D28"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75848 18.2317L6.80271 18.2464L6.84842 18.2555C6.8632 18.2584 6.87807 18.2614 6.89304 18.2644C7.37441 18.3606 7.95062 18.4757 8.43806 18.4757C12.9524 18.4757 16.6083 14.9733 16.6083 10.5257C16.6083 9.21034 16.3879 8.08458 15.7443 6.77318C15.7538 6.76705 15.7598 6.76416 15.7631 6.76272L15.7632 6.76265C15.7679 6.7606 15.7836 6.75361 15.8246 6.751C20.0657 7.24596 23.25 10.8287 23.25 14.9486C23.25 19.4592 19.4758 23.25 14.7247 23.25C11.088 23.25 7.9918 21.2544 6.7727 18.2911C6.76581 18.2686 6.76079 18.2486 6.75724 18.2313C6.75764 18.2314 6.75805 18.2315 6.75848 18.2317Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkBtn);
export default __webpack_public_path__ + "static/media/dark-btn.23684ba5786bc3af3109e259a81f5333.svg";
export { ForwardRef as ReactComponent };